import Meta from '@components/Meta/Meta';
import ScrollToTop from '@components/ScrollToTop/ScrollToTop';
import { DidomiSDK } from '@didomi/react';
import logger from '@utils/logger';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from 'react-router';
import Careers from './Careers/Careers';
import Landing from './Landing/Landing';
import Cookies from './Legal/Cookies/Cookies';
import Legal from './Legal/Legal';
import Privacy from './Legal/Privacy/Privacy';
import Terms from './Legal/Terms/Terms';
import NotFound from './NotFound/NotFound';
import Team from './Team/Team';

const App = () => (
	<>
		<HelmetProvider>
			<Meta />
			<ScrollToTop />
			<Routes>
				<Route path="/" element={<Landing />} />
				<Route path="/team" element={<Team />} />
				<Route path="/legal" element={<Legal />}>
					<Route path="terms-of-use" element={<Terms />} />
					<Route path="privacy-policy" element={<Privacy />} />
					<Route path="cookie-preferences" element={<Cookies />} />
				</Route>
				<Route path="/careers" element={<Careers />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
			<DidomiSDK
				noticeId="TCENLZHN"
				apiKey="8917a6d8-c64b-449d-b07a-54912600901b"
				gdprAppliesGlobally={true}
				onReady={(didomi) => logger.info({ didomi }, 'Didomi SDK ready')}
				onConsentChanged={(cwtToken) => logger.info({ cwtToken }, 'Didomi consent changed')}
				onNoticeShown={() => logger.info('Didomi notice shown')}
				onNoticeHidden={() => logger.info('Didomi notice hidden')}
			/>
		</HelmetProvider>
	</>
);

export default App;
